import { GarageVisitsService } from './garage-visits.service';
import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as GarageVisitsActions from './garage-visits.action';
import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import * as Models from '../../models/commonModels';
import { BannerService } from '../../shared/services/banner.service';
import { saveAs } from "file-saver";
import { HelperService } from '../helper/helper.service';
import { StorageService } from '../../shared/services/storage.service';

export interface GarageVisitsStateModel {
  GarageVisitsPlaceList: GarageVisitsModels.GarageVisitsPlaceListModel;
  GarageVisitsPlace: Models.Response<GarageVisitsModels.GarageVisitsPlaceModel>;
  GarageVisitsPlaceSearch: GarageVisitsModels.GarageVisitsPlaceSearch;
  GarageVisitsPlaceRemoveStatus: Models.ResponseBase;

  GarageBlockedHourList: GarageVisitsModels.GarageBlockedListModel;
  GarageBlockedHour: Models.Response<GarageVisitsModels.GarageBlockedModel>;
  GarageBlockedHourRemoveStatus: Models.ResponseBase;

  GarageBlockedDayList: GarageVisitsModels.GarageBlockedListModel;
  GarageBlockedDay: Models.Response<GarageVisitsModels.GarageBlockedModel>;
  GarageBlockedDayRemoveStatus: Models.ResponseBase;

  GarageVisitsSearch: GarageVisitsModels.GarageVisitsSearchModel;
  GagareVisitsList: Models.ResponseList<GarageVisitsModels.GarageVisitModel>;
  GagareVisit: Models.Response<GarageVisitsModels.GarageVisitModel>;
  GagareMainVisitsList: Models.ResponseList<GarageVisitsModels.GarageVisitModel>;

  GarageVisitsCarTypes: Models.Response<GarageVisitsModels.GarageVisitsCarTypeModel[]>;

  ProcessingFilteredPdf: number;
  ProcessingFilteredReport: number;
}

class DictionaryKeys {
  public static readonly GarageVisitsCarTypes = "GarageVisitsCarTypes";
}


@State<GarageVisitsStateModel>({
  name: 'GarageVisitsState',
  defaults: {
    GarageVisitsPlaceList: null,
    GarageVisitsPlace: null,
    GarageVisitsPlaceSearch: null,
    GarageVisitsPlaceRemoveStatus: null,

    GarageBlockedHourList: null,
    GarageBlockedHour: null,
    GarageBlockedHourRemoveStatus: null,

    GarageBlockedDayList: null,
    GarageBlockedDay: null,
    GarageBlockedDayRemoveStatus: null,

    GarageVisitsSearch: null,
    GagareVisitsList: null,
    GagareVisit: null,
    GagareMainVisitsList: null,

    ProcessingFilteredPdf: null,
    ProcessingFilteredReport: null,
    GarageVisitsCarTypes: null
  }
})

@Injectable()

export class GarageVisitsState {

  constructor(
    private helperService: HelperService,
    private GarageVisitsService: GarageVisitsService,
    private bannerService: BannerService,
    private storageService: StorageService
  ) { }

  @Selector()
  static GarageVisitsPlaceList(state: GarageVisitsStateModel) {
    return state.GarageVisitsPlaceList;
  }

  @Selector()
  static GarageVisitsPlace(state: GarageVisitsStateModel) {
    return state.GarageVisitsPlace;
  }

  @Selector()
  static GarageVisitsPlaceSearch(state: GarageVisitsStateModel) {
    return state.GarageVisitsPlaceSearch;
  }

  @Selector()
  static GarageVisitsPlaceRemoveStatus(state: GarageVisitsStateModel) {
    return state.GarageVisitsPlaceRemoveStatus;
  }

  @Selector()
  static GarageBlockedHourList(state: GarageVisitsStateModel) {
    return state.GarageBlockedHourList;
  }

  @Selector()
  static GarageBlockedHour(state: GarageVisitsStateModel) {
    return state.GarageBlockedHour;
  }

  @Selector()
  static GarageBlockedHourRemoveStatus(state: GarageVisitsStateModel) {
    return state.GarageBlockedHourRemoveStatus;
  }

  @Selector()
  static GarageBlockedDayList(state: GarageVisitsStateModel) {
    return state.GarageBlockedDayList;
  }

  @Selector()
  static GarageBlockedDay(state: GarageVisitsStateModel) {
    return state.GarageBlockedDay;
  }

  @Selector()
  static GarageBlockedDayRemoveStatus(state: GarageVisitsStateModel) {
    return state.GarageBlockedDayRemoveStatus;
  }



  @Selector()
  static GarageVisitsSearch(state: GarageVisitsStateModel) {
    return state.GarageVisitsSearch;
  }

  @Selector()
  static GarageVisits(state: GarageVisitsStateModel) {
    return state.GagareVisitsList;
  }

  @Selector()
  static GagareMainVisits(state: GarageVisitsStateModel) {
    return state.GagareMainVisitsList;
  }

  @Selector()
  static GarageVisit(state: GarageVisitsStateModel) {
    return state.GagareVisit;
  }


  @Selector()
  static ProcessingFilteredPdf(state: GarageVisitsStateModel) {
    return state.ProcessingFilteredPdf;
  }

  @Selector()
  static ProcessingFilteredReport(state: GarageVisitsStateModel) {
    return state.ProcessingFilteredReport;
  }

  @Selector()
  static GarageVisitsCarTypes(state: GarageVisitsStateModel) {
    return state.GarageVisitsCarTypes;
  }


  @Action(GarageVisitsActions.SetGarageVisitPlace)
  SetGarageVisitPlace(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.SetGarageVisitPlace
  ) {
    const errorMessage = 'Błąd zapisu Stanowiska.';

    this.GarageVisitsService.setGarageVisitPlace(action.GaragePlace).subscribe(
      ret => {
        context.setState(
          patch({
            GarageVisitsPlace: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.SetGarageVisitPlace', error);
        this.bannerService.error(errorMessage);

        let errorObj = new Models.Response<GarageVisitsModels.GarageVisitsPlaceModel>();
        errorObj.Success = false;
        errorObj.Message = errorMessage;

        context.setState(
          patch({
            GarageVisitsPlace: errorObj
          })
        );
      },
      () => { });
  }

  @Action(GarageVisitsActions.GetGarageVisitPlace)
  GetGarageVisitPlace(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisitPlace
  ) {
    const errorMessage = 'Błąd pobierania.';

    this.GarageVisitsService.getGarageVisitPlace(action.GaragePlace).subscribe(
      ret => {
        context.setState(
          patch({
            GarageVisitsPlace: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GetGarageVisitPlace', error);
        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(GarageVisitsActions.RemoveGarageVisitPlace)
  RemoveGarageVisitPlace(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.RemoveGarageVisitPlace
  ) {
    const errorMessage = 'Błąd usuwania stanowiska.';

    this.GarageVisitsService.removeGarageVisitPlace(action.GaragePlace).subscribe(
      ret => {
        context.setState(
          patch({
            GarageVisitsPlaceRemoveStatus: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.RemoveGarageVisitPlace', error);
        this.bannerService.error(errorMessage);

        let errorObj = new Models.ResponseBase();
        errorObj.Success = false;
        errorObj.Message = errorMessage;

        context.setState(
          patch({
            GarageVisitsPlaceRemoveStatus: errorObj
          })
        );
      },
      () => { });
  }

  @Action(GarageVisitsActions.GetGarageVisitPlaceList)
  GetGarageVisitPlaceList(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisitPlaceList
  ) {

    const errorMessage = 'Błąd pobierania listy stanowisk.';

    context.setState(
      patch({
        GarageVisitsPlaceList: null,
        GarageVisitsPlaceSearch: action.Search
      })
    );

    this.GarageVisitsService.getGaragePlaceList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            GarageVisitsPlaceList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.GetGarageVisitPlaceList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(GarageVisitsActions.SetGarageVisitPlaceSearch)
  SetGarageVisitPlaceSearch(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.SetGarageVisitPlaceSearch
  ) {
    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        GarageVisitsPlaceSearch: action.Search,
      })
    );

    this.helperService.consoleLog(action.Search);

    context.dispatch(new GarageVisitsActions.GetGarageVisitPlaceList(action.Search));
  }

  @Action(GarageVisitsActions.SetGarageVisitPlaceListPage)
  SetGarageVisitPlaceListPage(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.SetGarageVisitPlaceListPage
  ) {
    context.setState(
      patch({
        GarageVisitsPlaceSearch: action.Search,
      })
    );

    this.helperService.consoleLog(action.Search);
    context.dispatch(new GarageVisitsActions.GetGarageVisitPlaceList(action.Search));
  }

  @Action(GarageVisitsActions.ResetGarageVisitPlaceSearch)
  ResetGarageVisitPlaceSearch(context: StateContext<GarageVisitsStateModel>) {
    const state = context.getState();

    const newSearch = new GarageVisitsModels.GarageVisitsPlaceSearch();

    newSearch.ItemsPerPage = state.GarageVisitsPlaceSearch.ItemsPerPage;

    context.setState(
      patch({
        GarageVisitsPlaceSearch: newSearch,
      })
    );

    context.dispatch(new GarageVisitsActions.GetGarageVisitPlaceList(newSearch));
  }

  @Action(GarageVisitsActions.GetGarageBlockedHourList)
  GetGarageBlockedHourList(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageBlockedHourList
  ) {

    const errorMessage = 'Błąd pobierania listy zablokowanych godzin.';

    context.setState(
      patch({
        GarageBlockedHourList: null
      })
    );

    this.GarageVisitsService.getGarageBlockedHoursList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            GarageBlockedHourList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.GetGarageBlockedHourList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(GarageVisitsActions.SetGarageBlockedHour)
  SetGarageBlockedHour(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.SetGarageBlockedHour
  ) {
    const errorMessage = 'Błąd zapisu zablokowanej godziny.';

    this.GarageVisitsService.setGarageBlockedHour(action.Set).subscribe(
      ret => {
        context.setState(
          patch({
            GarageBlockedHour: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.SetGarageBlockedHour', error);
        this.bannerService.error(errorMessage);

        let errorObj = new Models.Response<GarageVisitsModels.GarageBlockedModel>();
        errorObj.Success = false;
        errorObj.Message = errorMessage;

        context.setState(
          patch({
            GarageBlockedHour: errorObj
          })
        );
      },
      () => { });
  }

  @Action(GarageVisitsActions.RemoveGarageBlockedHour)
  RemoveGarageBlockedHour(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.RemoveGarageBlockedHour
  ) {
    const errorMessage = 'Błąd usunięcia zablokowanej godziny.';

    this.GarageVisitsService.removeGarageBlockedHour(action.Remove).subscribe(
      ret => {
        context.setState(
          patch({
            GarageBlockedHourRemoveStatus: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.RemoveGarageBlockedHour', error);
        this.bannerService.error(errorMessage);

        let errorObj = new Models.ResponseBase();
        errorObj.Success = false;
        errorObj.Message = errorMessage;

        context.setState(
          patch({
            GarageBlockedHourRemoveStatus: errorObj
          })
        );
      },
      () => { });
  }


  @Action(GarageVisitsActions.GetGarageBlockedDaysList)
  GetGarageBlockedDaysList(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageBlockedDaysList
  ) {

    const errorMessage = 'Błąd pobierania listy zablokowanych dni.';

    context.setState(
      patch({
        GarageBlockedDayList: null
      })
    );

    this.GarageVisitsService.getGarageBlockedDayList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            GarageBlockedDayList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.GetGarageBlockedDaysList', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(GarageVisitsActions.SetGarageBlockedDay)
  SetGarageBlockedDay(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.SetGarageBlockedDay
  ) {
    const errorMessage = 'Błąd blokady dnia.';

    this.GarageVisitsService.setGarageBlockedDay(action.Set).subscribe(
      ret => {
        context.setState(
          patch({
            GarageBlockedDay: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.SetGarageBlockedDay', error);
        this.bannerService.error(errorMessage);

        let errorObj = new Models.Response<GarageVisitsModels.GarageBlockedModel>();
        errorObj.Success = false;
        errorObj.Message = errorMessage;

        context.setState(
          patch({
            GarageBlockedDay: errorObj
          })
        );
      },
      () => { });
  }

  @Action(GarageVisitsActions.RemoveGarageBlockedDay)
  RemoveGarageBlockedDay(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.RemoveGarageBlockedDay
  ) {
    const errorMessage = 'Błąd usunięcia blokady dnia.';

    this.GarageVisitsService.removeGarageBlockedDay(action.Remove).subscribe(
      ret => {
        context.setState(
          patch({
            GarageBlockedDayRemoveStatus: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.RemoveGarageBlockedDay', error);
        this.bannerService.error(errorMessage);

        let errorObj = new Models.ResponseBase();
        errorObj.Success = false;
        errorObj.Message = errorMessage;

        context.setState(
          patch({
            GarageBlockedDayRemoveStatus: errorObj
          })
        );
      },
      () => { });
  }


  @Action(GarageVisitsActions.DisposeGarageVisitsSearch)
  DisposeSearch(
    context: StateContext<GarageVisitsStateModel>
  ) {

    context.setState(
      patch({
        GarageVisitsSearch: null
      }));
  }


  @Action(GarageVisitsActions.GetGarageVisitList)
  GetGarageVisitList(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisitList
  ) {

    function patchContext(
      list:  Models.ResponseList<GarageVisitsModels.GarageVisitModel>
    ) {
      context.setState(
        patch({
          GagareVisitsList: list,
        })
      );
    }

    const emptyResponse = new Models.ResponseList<GarageVisitsModels.GarageVisitModel>();

    emptyResponse.Initialize(action.Search);

    patchContext(null);

    this.GarageVisitsService.getGarageVisits(action.Search).subscribe(
      (data) => {
        if (data.Success) {

          patchContext(data);

        } else {
          patchContext(emptyResponse);
        }
      },
      (error) => {
        patchContext(emptyResponse);

        this.bannerService.error("Błąd pobierania listy umówień.");

        this.helperService.SaveException("GetGarageVisitList", error);
      }
    );
  }

  @Action(GarageVisitsActions.GetGarageMainVisitList)
  GetGarageMainVisitList(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisitList
  ) {

    function patchContext(
      list: Models.ResponseList<GarageVisitsModels.GarageVisitModel>
    ) {
      context.setState(
        patch({
          GagareMainVisitsList: list,
        })
      );
    }

    const emptyResponse = new Models.ResponseList<GarageVisitsModels.GarageVisitModel>();

    emptyResponse.Initialize(action.Search);

    patchContext(null);

    this.GarageVisitsService.getGarageMainVisits(action.Search).subscribe(
      (data) => {
        if (data.Success) {

          patchContext(data);

        } else {
          patchContext(emptyResponse);
        }
      },
      (error) => {
        patchContext(emptyResponse);

        this.bannerService.error("Błąd pobierania listy umówień.");

        this.helperService.SaveException("GetGarageMainVisitList", error);
      }
    );
  }

  @Action(GarageVisitsActions.SetGarageVisitsSearch)
  SetGarageVisitsSearch(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.SetGarageVisitsSearch
  ) {
    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        GarageVisitsSearch: action.Search,
      })
    );

    this.helperService.consoleLog(action.Search);

    context.dispatch(new GarageVisitsActions.GetGarageMainVisitList(action.Search));
  }

  @Action(GarageVisitsActions.SetGarageVisitListPage)
  SetGarageVisitListPage(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.SetGarageVisitListPage
  ) {
    context.setState(
      patch({
        GarageVisitsSearch: action.Search,
      })
    );

    this.helperService.consoleLog(action.Search);
    context.dispatch(new GarageVisitsActions.GetGarageMainVisitList(action.Search));
  }

  @Action(GarageVisitsActions.ResetGarageVisitsSearch)
  ResetGarageVisitsSearch(context: StateContext<GarageVisitsStateModel>) {
    const state = context.getState();

    const newSearch = new GarageVisitsModels.GarageVisitsSearchModel();

    newSearch.ItemsPerPage = state.GarageVisitsSearch.ItemsPerPage;

    context.setState(
      patch({
        GarageVisitsSearch: newSearch,
      })
    );

    context.dispatch(new GarageVisitsActions.GetGarageMainVisitList(newSearch));
  }


  @Action(GarageVisitsActions.CreateGarageVisit)
  CreateGarageVisit(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.CreateGarageVisit
  ) {
    const errorMessage = 'Błąd rezerwacji nowej wizyty.';

    this.GarageVisitsService.createGarageVisit(action.GarageVisit).subscribe(
      ret => {

        if (ret.Success) {

          this.bannerService.success('Zarezerwowano nową wizytę.');

          if (ret.Message && ret.Message.length > 0) {
            this.bannerService.info(ret.Message);
          }
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        context.setState(
          patch({
            GagareVisit: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.CreateGarageVisit', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(GarageVisitsActions.SetGarageVisit)
  SetGarageVisit(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.SetGarageVisit
  ) {
    const errorMessage = 'Błąd zapisu zmian w rezerwacji wizyty.';

    this.GarageVisitsService.setGarageVisit(action.GarageVisit).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zapisano zmiany do wizyty.');

          context.setState(
            patch({
              GagareVisit: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.SetGarageVisit', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(GarageVisitsActions.GetGarageVisit)
  GetGarageVisit(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisit
  ) {
    const errorMessage = 'Błąd odczytu szczegółów zlecenia zamówienia opon.';

    this.GarageVisitsService.getGarageVisit(action.GarageVisitId).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              GagareVisit: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GetGarageVisit', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(GarageVisitsActions.DeleteGarageVisit)
  DeleteGarageVisit(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.DeleteGarageVisit
  ) {
    const errorMessage = 'Błąd usunięcia wizyty.';

    this.GarageVisitsService.deleteGarageVisit(action.GarageVisitId).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              GagareVisit: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.DeleteGarageVisit', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(GarageVisitsActions.GetGarageVisitFilteredPdfList)
  GetGarageVisitFilteredPdfList(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisitFilteredPdfList
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie pliku pdf, proszę czekać.');

    this.GarageVisitsService.getPdfFilteretList(action.Search).subscribe(ret => {
      const file = new File([ret], `Umowienia-${this.helperService.TimeStamp()}.pdf`, { type: 'application/pdf' });
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GetGarageVisitFilteredPdfList', error);

        this.bannerService.error('Błąd pobierania pliku pdf.');
      },
      () => {
        context.setState(
          patch({
            ProcessingFilteredPdf: Math.random()
          })
        );
      }
    );
  }

  @Action(GarageVisitsActions.GetGarageVisitPlaceFilteredPdfList)
  GetGarageVisitPlaceFilteredPdfList(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisitFilteredPdfList
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie pliku pdf, proszę czekać.');

    this.GarageVisitsService.getPdfPlacesList(action.Search).subscribe(ret => {
      const file = new File([ret], `Umowienia-${this.helperService.TimeStamp()}.pdf`, { type: 'application/pdf' });
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GetGarageVisitPlaceFilteredPdfList', error);

        this.bannerService.error('Błąd pobierania pliku pdf.');
      },
      () => {
        context.setState(
          patch({
            ProcessingFilteredPdf: Math.random()
          })
        );
      }
    );
  }

  @Action(GarageVisitsActions.GetGarageVisitFilteredReportList)
  GetGarageVisitFilteredReportList(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisitFilteredReportList
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie raportu, proszę czekać.');


    this.GarageVisitsService.getFilteredReport(action.Search).subscribe(ret => {
      const file = new File([ret], `Umowienia-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GetGarageVisitFilteredReportList', error);

        this.bannerService.error('Błąd pobierania raportu depozytów.');
      },
      () => {

        context.setState(
          patch({
            ProcessingFilteredReport: Math.random()
          })
        );
      }
    );
  }

  @Action(GarageVisitsActions.GetGarageVisitsCarTypeDictionary)
  GetGarageVisitsCarTypeDictionary(
    context: StateContext<GarageVisitsStateModel>,
    action: GarageVisitsActions.GetGarageVisitsCarTypeDictionary
  ) {





    const errorMessage = 'Błąd pobierania typów samochodów.';

    let storageKey = DictionaryKeys.GarageVisitsCarTypes;

    //context.setState(
    //  patch({
    //    GarageVisitsCarTypes: this.storageService.getItemJSON(storageKey)
    //  })
    //);



    const state = context.getState();

    if (!state.GarageVisitsCarTypes) {

      this.GarageVisitsService.GetGarageVisitsCarTypeModelDictionary().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              GarageVisitsCarTypes: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(errorMessage);
        }
      },
        (error) => {

          this.helperService.SaveException('GarageVisitsActions.GetGarageVisitsCarTypeDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }
} 
